import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import heroArt from '../../theme/assets/redesign/events/hero.webp';
import heroArtMobile from '../../theme/assets/redesign/events/hero.webp';


// Шапка «Events» (макеты 2416:3630 / 2464:4804)
const CabinetEventsMain = () => {
    const {t} = useTranslation();

    return (
        <section className={Styles.hero}>
            <div className={Styles.heroArt}>
                <img className={Styles.desktopOnly} src={heroArt} alt=""/>
                <img className={Styles.mobileOnly} src={heroArtMobile} alt=""/>
            </div>
            <div className={Styles.title}>{t('События')}</div>
            <p className={`${Styles.text} ${Styles.desktopOnly}`}>
                {t('Здесь будут запускаться Side Events — специальные активности, которые помогут вам заранее отслеживать новые волны хайпа и зарабатывать на них. Следите за обновлениями, подробности появятся совсем скоро.')}
            </p>
            <p className={`${Styles.text} ${Styles.mobileOnly}`}>
                {t('Ловите новые волны хайпа заранее и зарабатывайте на них.')}
            </p>
        </section>
    );
};

export default CabinetEventsMain;
